module.exports = __webpack_public_path__ + "static/sport/slide6.e16f1dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/year/slide6.png
// module id = GV1Y
// module chunks = 0